import { Pipe, PipeTransform } from '@angular/core';

function isAlphanumeric(str: string) {
  if (str) {
    const regEx = new RegExp(/^[A-Za-zÀ-ÖØ-öø-ÿ0-9]+$/);
    return regEx.test(str);
  }
  return false;
}

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(str: string, charLimit: number, tail?: string, cutOffNonAlphaNumeric?: boolean): any {
    let result = ``;
    let words: any;

    if (!cutOffNonAlphaNumeric) {
      cutOffNonAlphaNumeric = false;
    }

    if (str) {

      if (str.includes(` `)) {
        words = str.split(` `);
      } else {
        words = str;
      }

      if (!tail) {
        tail = ``;
      }

      if (str.length > charLimit) {
        // looping through words
        for (const word of words) {
          // if the next word will put it over the charLimit (minus the length of the tail)
          if (charLimit - tail.length >= result.length + word.length) {
            result += `${word} `;
          } else {
            break;
          }
        }

        result = result.trim();

        // if you need to remove the last character if it's not a letter or number
        if (cutOffNonAlphaNumeric && !isAlphanumeric(result.charAt(result.length - 1))) {
          result = result.substring(0, result.length - 1);
        }

        result += tail;
      } else {
        result = str;
      }
    }

    return result;
  }
}
